import States from './States.js';

export default function GetStateLabel(stateValue) {
    let states = States();
    let stateLabel = states.find(e => e.value === stateValue);
    if (stateLabel && stateLabel.label) {
       return  stateLabel.label;
    }
    return stateValue;
} 


// WEBPACK FOOTER //
// ./src/components/Helpers/Lists/GetStateLabel.js